import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-paper': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M372.6 112.6V101.8C372.6 58.2 332.1 25.1 289.5 36.3 263.9-13.2 195.4-11.2 171.5 37 130.3 26.5 89.1 57.9 89.1 102V228.1C69.2 220.7 45.8 223.1 27.1 237-2.3 258.8-8.7 300.3 12.5 330.2L132.5 498.6A32-32 0 0 1 158.5 512H381.4C396.3 512 409.3 501.7 412.6 487.2L442.8 356.2A203.6-203.6 0 0 1 448 310.6V179C448 138.4 412.5 107 372.6 112.6zM400 310.6C400 322.3 398.7 334 396 345.4L368.7 464H166.8L51.6 302.3C37.2 282 66.6 259.5 81 279.7L108.1 317.8C117.1 330.4 137.1 324.1 137.1 308.5V102C137.1 76.4 173.7 77.2 173.7 102.7V256C173.7 264.8 180.9 272 189.7 272H196.6C205.4 272 212.6 264.8 212.6 256V67C212.6 41.3 249.1 42.2 249.1 67.7V256C249.1 264.8 256.3 272 265.1 272H272C280.8 272 288 264.8 288 256V101.1C288 75.5 324.6 76.3 324.6 101.8V256C324.6 264.8 331.7 272 340.6 272H347.4C356.3 272 363.4 264.8 363.4 256V179.7C363.4 153.4 400 154.1 400 179V310.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-paper.js
// module id = +DO6
// module chunks = 144